import { createSlice } from '@reduxjs/toolkit';
import { TYPE_TO_SELECT } from '../../Components/MainPages/Components/FilterWidget/dynamicOption';

const initialState = {
    topCategoryList: [],
    categoryList: [],
    categoryPropertiesList: [],
    searchableCategoryPropertiesList: [],
    categoryToImg: {},
};

const { actions, reducer } = createSlice({
    name: 'common/categoryInfo',
    initialState,
    reducers: {
        setTopCategoryList: (state, action) => {
            const categoryList = action.payload
                .filter(category => !category.depth)
                .map(topCategory => {
                    return { value: topCategory.categoryCode, label: topCategory.categoryName };
                });
            state.topCategoryList = categoryList;
        },
        setCategoryList: (state, action) => {
            state.categoryList = [...action.payload];
        },
        setCategoryPropertiesList: (state, action) => {
            const propertiesList = action.payload;
            state.categoryPropertiesList = propertiesList;
            state.searchableCategoryPropertiesList = propertiesList.filter(
                v => v.isSearchable === 'Y' && TYPE_TO_SELECT.includes(v.inputType),
            );
        },
        setAllCategoryList: (state, action) => {
            const categoryList = [...action.payload];

            if (categoryList && Array.isArray(categoryList)) {
                categoryList.sort((a, b) => (a.categoryCodePath > b.categoryCodePath ? 1 : -1));
                state.categoryToImg = {};
                categoryList.forEach(category => {
                    state.categoryToImg[category.categoryCode] = category.normalIconURL;
                });
            }

            state.categoryList = categoryList;
            state.topCategoryList = categoryList
                .filter(category => !category.depth)
                .map(topCategory => {
                    return { value: topCategory.categoryCode, label: topCategory.categoryName };
                });
        },
    },
});

export const { setTopCategoryList, setCategoryList, setCategoryPropertiesList, setAllCategoryList } = actions;
export default reducer;
